import { z } from 'zod';

import { type IEndpointSchema, makeEndpoint } from '../common';

export const RearrangeVibeRequestSchema = z.object({
  vibeIds: z.array(z.string().uuid()),
});

export const RearrangeVibeEndpoint = makeEndpoint({
  method: 'PUT',
  url: (params: { brandId: string }) => `v1/brands/${params.brandId}/vibes/rearrange`,
  responseSchema: z.void(),
  requestSchema: RearrangeVibeRequestSchema,
});

export type IRearrangeVibeEndpoint = IEndpointSchema<typeof RearrangeVibeEndpoint>;
